import {Component, inject, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RequestUserDto} from '../../../../generated-model/model';
import {FormsModule, NgForm} from '@angular/forms';
import {NgClass} from '@angular/common';
import {
  emailPattern,
  lotNoPattern,
  passwordPattern,
  telephoneNumber,
  updateFormAndValidity
} from '../../../app.constants';
import {DigitOnlyModule} from '@uiowa/digit-only';
import {UserRegisterResource} from '../../../service/UserRegisterResource';
import {AlertDialogService} from '../../../shared/commons/dialog/alert-dialog/alert-dialog.service';
import {EnglishDigitsOnlyDirective} from '../../../shared/english-digits-only.directive';

export type ThaiDDto = {code?: string, pid?: string, given_name?: string, family_name?: string,registerUuid?:string};

@Component({
  selector: 'app-create-user',
  standalone: true,
  imports: [
    FormsModule,
    NgClass,
    DigitOnlyModule,
    EnglishDigitsOnlyDirective
  ],
  templateUrl: './create-user.component.html',
  styleUrl: './create-user.component.scss'
})
export class CreateUserComponent implements OnInit {
  @ViewChild('form') form: NgForm
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private userRegisterResource = inject(UserRegisterResource);
  private alertDialogService = inject(AlertDialogService);
  thaiD : ThaiDDto = {}
  visibleConfirm: boolean = false;
  visibleReConfirm: boolean = false;
  param : RequestUserDto = {}
  confirmPassword : string
  protected readonly emailPattern = emailPattern;
  protected readonly passwordPattern = passwordPattern;

  passwordPatternString: string = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).{6,}$";
  passwordValidations = {
    minLength: false,
    hasUpperCase: false,
    hasLowerCase: false,
    hasDigit: false
  };

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.thaiD = {...params}
      this.param.code = this.thaiD.code
      this.param.registerUuid = this.thaiD.registerUuid
      this.param.email = this.thaiD.registerUuid
    });
  }

  viewPassword(value: string) {
    if (value == 'confirm') {
      this.visibleConfirm = !this.visibleConfirm;
    }
    if (value == 'reconfirm') {
      this.visibleReConfirm = !this.visibleReConfirm;
    }

  }

  onPasswordInput(): void {
    const password = this.param.password || '';
    // ตรวจสอบเงื่อนไขต่างๆ
    this.passwordValidations = {
      minLength: password.length >= 6,
      hasUpperCase: /[A-Z]/.test(password),
      hasLowerCase: /[a-z]/.test(password),
      hasDigit: /[0-9]/.test(password)
    };
  }

  // ตรวจสอบว่ารหัสผ่านถูกต้องตามเงื่อนไขทั้งหมดหรือไม่
  get passwordValid(): boolean {
    return this.passwordValidations.minLength &&
      (this.passwordValidations.hasUpperCase ||
      this.passwordValidations.hasLowerCase) &&
      this.passwordValidations.hasDigit;
  }


  save() {
    let valid = updateFormAndValidity(this.form)
    if (valid && this.param.password == this.confirmPassword) {
      this.userRegisterResource.register(this.param).subscribe( {
        next: e => {
          this.router.navigate(['/login']);
        },
        error:err => {
          if(err?.error?.message == "User exists with same username"){
            this.alertDialogService.open({content:"ไม่สามารถใช้ชื่อผู้ใช้งานนี้ได้ เนื่องจากมีผู้ใช้งานท่านอื่นใช้แล้ว กรุณาตั้งชื่อใหม่"});

          }
          else{
            this.alertDialogService.open({content: err?.error?.message});
          }
        }
      })
    }
  }

  protected readonly lotNoPattern = lotNoPattern;
  protected readonly telephoneNumber = telephoneNumber;
}
